import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireinpuneforoutstationandlocal() {



  const cardData =
  {
    keyword: 'Bus Hire in Pune for Outstation and Local Trip',
    heading: 'Sanavi Travels: Bus Hire in Pune for Outstation and Local Trip',
    headingDescription: 'Sanavi Travels offers reliable Bus Hire in Pune for Outstation and Local Trips, providing safe, comfortable, and well-organized transportation for families, corporate groups, tourists, schools, colleges, and event organizers. Our fleet of AC and Non-AC buses ranging from 20 to 50 seaters, along with tempo travellers on request, is well-maintained with spacious seating, ample legroom, and sufficient luggage space to ensure a smooth journey. We cater to local trips within Pune for city sightseeing, corporate travel, weddings, and picnic tours, as well as outstation trips to destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Aurangabad, Kolhapur, and Konkan, ensuring long-distance comfort and safety. With experienced chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, hassle-free, and reliable travel, offering convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station. Choose Sanavi Travels for trusted bus hire services in Pune for outstation and local trips, delivering comfort, safety, and a seamless group travel experience.',

    top: 'Top Places to Visit in Pune  with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a symbol of Maratha pride. Once the seat of Peshwa Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and well-laid gardens. Despite being partially destroyed by fire, the ruins still echo royal grandeur. The evening light-and-sound show brings Maratha history to life, making Shaniwar Wada the cultural and historical heart of Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a landmark deeply connected to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying photographs, personal belongings, and historical documents. The palace’s sprawling gardens and Italian-style architecture create a serene ambiance. Aga Khan Palace is a symbol of sacrifice, peace, and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual site, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations, music, and cultural events. The temple trust is also known for extensive charitable work. Dagdusheth Ganpati represents the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the heroic sacrifice of Tanaji Malusare in 1670 for Chhatrapati Shivaji Maharaj. Situated atop a rugged hill, the fort offers panoramic views of the Sahyadri ranges. Visitors can trek or drive up to explore ancient gates, memorials, and viewpoints. Sinhagad combines history, adventure, and natural beauty, making it a favorite among tourists and trekkers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Located in the busy city center, it offers a calm and meditative atmosphere. Monolithic pillars and ancient carvings showcase early Indian architectural excellence. Pataleshwar is a hidden heritage retreat offering spiritual solace in Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s cultural and artistic heritage. The collection includes musical instruments, traditional household items, sculptures, and ornaments. The recreated Mastani Mahal is a highlight. The museum is a must-visit for art, history, and culture enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering stunning panoramic views of the city. After climbing 103 stone steps, visitors reach the Parvati Temple complex, built during the Peshwa era. Smaller shrines and a museum enhance its cultural appeal. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from around the world. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. The serene environment promotes relaxation and personal growth. Osho Ashram is Pune’s international center for spiritual and holistic wellness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns create a tranquil environment. Families, joggers, and photography enthusiasts enjoy leisurely walks. The garden blends Japanese aesthetics with Indian nature, offering a peaceful sanctuary in the urban landscape."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune, especially during monsoon. The reservoir and surrounding hills offer scenic views, while street vendors provide local snacks and refreshments. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla Dam is ideal for weekend getaways, sunset views, and family outings."
  }
]
,




"services": [
  {
    "name": "Bus Hire in Pune for Outstation and Local Trip",
    "description": "Bus Hire in Pune for Outstation and Local Trip provides reliable and comfortable buses for both city travel and long-distance journeys. Ideal for families, corporate groups, and tourists, these vehicles ensure safe, punctual, and convenient travel with experienced drivers and spacious interiors."
  },
  {
    "name": "Local and Outstation Bus Rental Pune",
    "description": "Local and Outstation Bus Rental Pune offers flexible rental services for buses suitable for city tours as well as outstation trips. Well-maintained vehicles with comfortable seating, luggage space, and professional drivers guarantee a smooth travel experience for groups of all sizes."
  },
  {
    "name": "AC Bus Hire Pune",
    "description": "AC Bus Hire Pune provides air-conditioned buses for both local and long-distance travel. Perfect for comfortable city tours, weekend trips, or corporate outings, these vehicles ensure passengers travel in a cool and relaxing environment with professional chauffeurs handling all routes."
  },
  {
    "name": "Luxury Bus Rental Pune",
    "description": "Luxury Bus Rental Pune offers premium buses equipped with plush seating, entertainment options, and ample luggage space. Ideal for VIP travel, corporate trips, or family vacations, these luxury buses provide a stylish and comfortable travel experience."
  },
  {
    "name": "Corporate Bus Hire Pune",
    "description": "Corporate Bus Hire Pune caters to business groups and office staff, providing spacious and well-equipped buses for corporate travel. Chauffeurs maintain punctuality and safety, allowing executives to focus on work or relax during the journey."
  },
  {
    "name": "Family Bus Hire Pune",
    "description": "Family Bus Hire Pune ensures safe and comfortable transport for family outings and trips. With spacious seating, luggage-friendly interiors, and experienced drivers, these buses make group travel convenient and stress-free."
  },
  {
    "name": "Affordable Bus Hire Pune",
    "description": "Affordable Bus Hire Pune offers budget-friendly options without compromising on comfort or safety. Well-maintained buses and professional drivers make it ideal for families, friends, or corporate groups seeking economical travel solutions."
  },
  {
    "name": "Chauffeur Driven Bus Pune",
    "description": "Chauffeur Driven Bus Pune provides professional drivers to manage routes and traffic, allowing passengers to enjoy a hassle-free journey. Suitable for local city trips or outstation travel, these buses combine convenience, safety, and comfort."
  },
  {
    "name": "Group Travel Bus Pune",
    "description": "Group Travel Bus Pune caters to large groups requiring reliable and spacious buses. Perfect for corporate events, school trips, family outings, or friends traveling together, these buses ensure a smooth and enjoyable travel experience."
  },
  {
    "name": "Best Bus Hire Service Pune",
    "description": "Best Bus Hire Service Pune offers top-quality buses and professional service for a superior travel experience. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure timely, safe, and enjoyable journeys."
  },
  {
    "name": "Pune Bus Booking Service",
    "description": "Pune Bus Booking Service provides easy and hassle-free reservations for buses in Pune. Flexible booking options, reliable vehicles, and professional chauffeurs ensure convenient travel for city trips or outstation journeys."
  },
  {
    "name": "Tourist Bus Hire Pune",
    "description": "Tourist Bus Hire Pune offers buses specifically for sightseeing and tourist travel. Comfortable, spacious, and equipped for long-distance travel, these buses are ideal for exploring Pune and nearby attractions."
  },
  {
    "name": "Event Bus Rental Pune",
    "description": "Event Bus Rental Pune provides buses for parties, weddings, festivals, and corporate events. Spacious and well-maintained, these buses ensure safe, reliable, and convenient travel for all types of events."
  },
  {
    "name": "Weekend Trip Bus Pune",
    "description": "Weekend Trip Bus Pune offers buses for short trips and weekend getaways. Comfortable seating, ample luggage space, and experienced drivers make these buses ideal for family trips, friends’ outings, or group excursions."
  },
  {
    "name": "Travel Bus Service Pune",
    "description": "Travel Bus Service Pune provides dependable buses for city travel, outstation trips, and tourist journeys. Professional chauffeurs, well-maintained vehicles, and spacious interiors ensure safe, comfortable, and enjoyable travel for groups of any size."
  }
],
"tableData": [
  ["Bus Hire in Pune for Outstation and Local Trip", "Local and Outstation Bus Rental Pune"],
  ["AC Bus Hire Pune", "Luxury Bus Rental Pune"],
  ["Corporate Bus Hire Pune", "Family Bus Hire Pune"],
  ["Affordable Bus Hire Pune", "Chauffeur Driven Bus Pune"],
  ["Group Travel Bus Pune", "Best Bus Hire Service Pune"],
  ["Pune Bus Booking Service", "Tourist Bus Hire Pune"],
  ["Event Bus Rental Pune", "Weekend Trip Bus Pune"],
  ["Travel Bus Service Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire in Pune for Outstation and Local Trip with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable bus hire services in Pune for both outstation and local trips, perfect for group tours, family outings, corporate travel, school excursions, and sightseeing."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and well‑serviced buses providing ample seating and luggage space for a comfortable journey, whether local or outstation."
  },
  {
    "WhyChooseheading": "Experienced Drivers for All Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune city, nearby destinations, and outstation highways, ensuring safe, punctual, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for bus rentals in Pune, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, route planning, and travel queries for both local and outstation trips."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, one‑way, round‑trip, or customized bus hire plans based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience for passengers."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus hire in Pune for both outstation and local trips."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer bus hire in Pune for outstation and local trips?',
    answer: 'Yes, Sanavi Travels provides comfortable and well‑maintained buses for both local and outstation travel from Pune.'
  },
  {
    question: 'How can I book a bus for local or outstation travel with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for hire in Pune?',
    answer: 'We offer a variety of buses including mini, medium, and large capacity buses suitable for local outings and long‑distance travel.'
  },
  {
    question: 'Are drivers included in the bus hire rental?',
    answer: 'Yes, all bus rentals include experienced and professional drivers familiar with local and outstation routes.'
  },
  {
    question: 'Is the bus hire service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before trips?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey to ensure passenger safety.'
  },
  {
    question: 'Can I customize the bus rental plan for my trip?',
    answer: 'Absolutely. Sanavi Travels offers customized bus hire plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for bus hire bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your local or outstation trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sunil Deshpande',
    feedback: 'Booked a bus for both local sightseeing and outstation travel with Sanavi Travels. Comfortable bus, professional driver, and excellent service throughout!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Meera Kulkarni',
    feedback: 'Great experience! The bus was clean, the service was punctual, and our group enjoyed both local and outstation trips. Highly recommended!',
    rating: 5
  }
];









































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire in Pune for Outstation and Local Trip - Sanavi Travels",
  "description": "Book bus hire in Pune for outstation and local trips with Sanavi Travels. AC and luxury buses for corporate travel, family outings, tourist travel, events, weekend trips, and comfortable chauffeur-driven group transportation.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Bus Hire in Pune for Outstation and Local Trip | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses in Pune with Sanavi Travels for local travel and outstation trips. Ideal for corporate events, family travel, tourism, group outings, weekend trips, and event transportation."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireinpuneforoutstationandlocal;